module.exports = __webpack_public_path__ + "static/logo-9850ab8ddab8a93e38688bc43447ddb9.png";